import { z } from 'zod';

export const OrganizationInventoryPolicySlugSchema = z.enum([
  'CONSUMPTION_BEFORE_INVOICE_MODE',
  'DEFERRED_CONSUMPTION_MAX_DAYS',
  'INVOICE_COST_REQUIRED_ON_CONFIRM',
  'RESERVE_ON',
  'RESERVE_SCOPE',
  'LOT_PICKING',
  'NO_LOCAL_STOCK_BEHAVIOR',
  'NF_BLOCK_MODE',
  'ALLOW_NEGATIVE_AVAILABLE',
  'PURCHASE_ENTRY_PLACE',
  'LOT_REQUIRED',
  'NETWORK_STOCK_LOOKUP_ON_PO',
  'CD_REPLENISH_ON_PO',
  'CD_REPLENISH_ON_RESERVE',
  'THIRD_PARTY_IN_OWN_REPORTS',
  'TRANSIT_BLOCKS_ORIGIN',
  'BARCODE_UNIT_PICK',
  'PHYSICAL_RECEIPT_PERMISSION',
]);

export const PhysicalReceiptPermissionGroupSchema = z.object({
  id: z.uuid(),
  name: z.string().min(1),
  templateSlug: z.string().min(1).nullable(),
  scopeType: z.enum(['TENANT', 'PLACE']),
  hasInventoryReceive: z.boolean(),
});

export const OrganizationInventoryPolicyItemSchema = z.object({
  slug: OrganizationInventoryPolicySlugSchema,
  value: z.string().min(1),
  resolvedFrom: z.enum(['TENANT', 'DEFAULT']),
  validFrom: z.iso.datetime().nullable(),
});

export const OrganizationInventorySettingsResponseSchema = z.object({
  policies: z.array(OrganizationInventoryPolicyItemSchema),
  physicalReceiptPermissionGroups: z.array(PhysicalReceiptPermissionGroupSchema),
});

export const ReplaceOrganizationInventoryPoliciesBodySchema = z.object({
  policies: z
    .array(
      z.object({
        slug: OrganizationInventoryPolicySlugSchema,
        value: z.string().trim().min(1).max(120),
      }),
    )
    .min(1),
  physicalReceiptPermissionGroupIds: z.array(z.uuid()).optional(),
});

export type OrganizationInventoryPolicyItem = z.infer<typeof OrganizationInventoryPolicyItemSchema>;
export type OrganizationInventorySettingsResponse = z.infer<
  typeof OrganizationInventorySettingsResponseSchema
>;
export type ReplaceOrganizationInventoryPoliciesBody = z.infer<
  typeof ReplaceOrganizationInventoryPoliciesBodySchema
>;
